module.exports = __webpack_public_path__ + "poster1.jpg?49151a889b8692f836c848b36f04f5a1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/poster1.jpg
// module id = 3
// module chunks = 0